// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OAtn","placeholdersHeader":"styles_placeholdersHeader__3DsNj","editorStyle":"styles_editorStyle__1aMHW","placeholdersBox":"styles_placeholdersBox__3MLuj"};